
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-shops/[slug]",
      function () {
        return require("private-next-pages/best-shops/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-shops/[slug]"])
      });
    }
  